import script from "./VitaBeruTimeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaBeruTimeline.vue?vue&type=script&setup=true&lang=ts"

import "./VitaBeruTimeline.vue?vue&type=style&index=0&id=3bae209c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bae209c"]])

export default __exports__